import { ReactElement } from 'react';
import { useData } from '../context/data.context';

type ParametersProps = {
  groups: number;
  sensors: number;
  expandAll: boolean;
  setExpandAll: () => void;
};

/**
 * A Parameters component will renders the list of parameters.
 * @param props - Properties of Parameters component.
 * @returns - A HTML for list of Parameters.
 */
export default function Parameters(props: ParametersProps): ReactElement {
  const { groups, sensors, expandAll, setExpandAll } = props;
  const { parameters, loading } = useData();
  if (loading && parameters.length === 0) {
    return <div />;
  }
  return (
    <div className="bg-white dark:bg-container-700 flex text-gray-400 dark:text-gray-400 text-sm font-medium border-b border-b-gray-300 dark:border-b-gray-900 sticky top-0">
      <div className="px-6 py-3 pr-[1.76875rem] w-[22%] flex items-center  ">
        <div>
          {groups} Groups | {sensors} Devices
        </div>

        <div
          role="button"
          onClick={setExpandAll}
          onKeyDown={setExpandAll}
          tabIndex={0}
          className="material-icons-outlined pl-0.5 cursor-pointer text-md "
        >
          {!expandAll ? 'expand_more' : 'expand_less'}
        </div>
      </div>
      <div
        style={{ gridTemplateColumns: `repeat(${parameters.length}, minmax(0, 1fr))` }}
        className={`flex-1 grid `}
      >
        {parameters.map((currentParameter) => (
          <div
            key={currentParameter.parameterName}
            className="flex justify-center px-6 py-3 text-center items-center"
          >
            {currentParameter.shortName}
            {currentParameter.shortName === 'Pressure' ? (
              <span className="material-icons-outlined text-sm  pl-1 cursor-pointer text-gray-400 text-center">
                arrow_downward
              </span>
            ) : (
              ' '
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
